import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2, Lock } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password.trim());
      nav("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Accesso non riuscito. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B1220] px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="font-heading text-4xl text-[#F4F8FF]">Advanced Post Graduate Excellence</div>
          <p className="text-sm text-[#F4F8FF]/50 mt-2 tracking-wide uppercase">Area riservata</p>
        </div>
        <form onSubmit={submit} data-testid="login-form" className="bg-[#F4F8FF] rounded-sm p-8 md:p-10">
          <div className="flex items-center gap-2 text-[#1452F0] mb-6">
            <Lock className="h-5 w-5" strokeWidth={1.5} />
            <h1 className="font-heading text-2xl text-[#0B1220]">Accedi al pannello</h1>
          </div>
          <div className="space-y-6">
            <div>
              <label className="overline mb-1 block">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="editorial-input" placeholder="admin@..." />
            </div>
            <div>
              <label className="overline mb-1 block">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="editorial-input" placeholder="••••••••" />
            </div>
          </div>
          {error && <p data-testid="login-error" className="text-sm text-[#A63C3C] mt-4">{error}</p>}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full mt-8 bg-[#1452F0] text-[#F4F8FF] hover:bg-[#0E3DC0] transition-colors rounded-sm px-8 py-4 text-sm font-medium tracking-wide flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
